import type { LngLatArr, MapBounds, MapPOI } from 'shared/map/interfaces';
import type { BoundingBox, MapOffer } from '@/interfaces';

export const DEFAULT_BOUNDS: MapBounds = {
    sw: [-10, 30], // Southwest: Atlantic/North Africa
    ne: [40, 60], // Northeast: Eastern Europe/Scandinavia
};

/**
 * Convert offers to MapPOI format for display on the map.
 * Only includes offers with valid coordinates.
 */
export const offersToMapPois = (offers: MapOffer[]): MapPOI[] => {
    const pois: MapPOI[] = [];
    for (const offer of offers) {
        if (offer.latitude != null && offer.longitude != null) {
            pois.push({
                id: offer.offerId,
                name: offer.hotelName,
                coordinates: [offer.longitude, offer.latitude] as LngLatArr,
                price: offer.pricePerPerson,
            });
        }
    }
    return pois;
};

export const enclosingBoundingBox = (boxes: BoundingBox[]): BoundingBox | undefined =>
    boxes.length === 0
        ? undefined
        : {
              minLat: Math.min(...boxes.map((b) => b.minLat)),
              minLon: Math.min(...boxes.map((b) => b.minLon)),
              maxLat: Math.max(...boxes.map((b) => b.maxLat)),
              maxLon: Math.max(...boxes.map((b) => b.maxLon)),
          };
